import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import tableCellClasses  from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { styled } from '@mui/material/styles';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function CollapsibleTable({ columns, data, rowClickHandler }) {
  let jsondatastring=JSON.stringify(data);
  let jsondata=JSON.parse(jsondatastring);
  // Render the UI for your table

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <StyledTableRow>
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell>KYR METRICS</StyledTableCell>
            <StyledTableCell />
            <StyledTableCell />
          </StyledTableRow>
          <TableRow>
            <StyledTableCell />
            <StyledTableCell>Apr</StyledTableCell>
            <StyledTableCell>Invested Value</StyledTableCell>
            <StyledTableCell>Rewards Value</StyledTableCell>
            <StyledTableCell>Total Value</StyledTableCell>
            
          </TableRow>
        </TableHead>
        <TableBody>
            <StyledTableRow>
              <StyledTableCell>Liquid Pool Returns</StyledTableCell>
              <StyledTableCell>{parseFloat(jsondata.liquidPoolReturns.apr*100).toFixed(6)}%</StyledTableCell>
              <StyledTableCell>{jsondata.liquidPoolReturns.investedValue}</StyledTableCell>
              <StyledTableCell>{jsondata.liquidPoolReturns.rewardsValue}</StyledTableCell>
              <StyledTableCell>{jsondata.liquidPoolReturns.totalValue}</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell >Validator Returns</StyledTableCell>
              <StyledTableCell>{parseFloat(jsondata.validatorReturns.apr*100).toFixed(6)}%</StyledTableCell>
              <StyledTableCell>{jsondata.validatorReturns.investedValue}</StyledTableCell>
              <StyledTableCell>{jsondata.validatorReturns.rewardsValue}</StyledTableCell>
              <StyledTableCell>{jsondata.validatorReturns.totalValue}</StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell>Auto Compounding Returns</StyledTableCell>
              <StyledTableCell>{parseFloat(jsondata.autoCompoundingReturns.apr*100).toFixed(6)}%</StyledTableCell>
              <StyledTableCell>{jsondata.autoCompoundingReturns.investedValue}</StyledTableCell>
              <StyledTableCell>{jsondata.autoCompoundingReturns.rewardsValue}</StyledTableCell>
              <StyledTableCell>{jsondata.autoCompoundingReturns.totalValue}</StyledTableCell>
            </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CollapsibleTable;
